import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from 'react-query';
import { Dropdown } from 'semantic-ui-react';
import { virtkbd } from '../../../utils';
import * as API from '../../API';
import './KbSectorSelector.scss';
export const KbSectorSelector = ({ className, preventDefault, stayInFocus, clearable, scrollTop = true, onSelect, onClick, prompt, value, pathTemplate = '#totalrangering//{aar}' }) => {
    var _a, _b, _c, _d, _e, _f;
    // Construct regular expression from pathTemplate to extract current field value
    const fieldName = (_b = (_a = pathTemplate.match(/\{([^}]+)\}/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : 'sec';
    const pattern = `${pathTemplate.replace(`{${fieldName}}`, '(\[a-z]{2,3})')}`;
    const r = new RegExp(pattern);
    let currentSelection = value !== null && value !== void 0 ? value : ((_d = (_c = window.location.hash.match(r)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : '');
    const { data: codeListData } = useQuery('kb/kodeliste', API.fetchCodeList);
    const opts = (_f = Object.entries((_e = codeListData === null || codeListData === void 0 ? void 0 : codeListData.sektorer) !== null && _e !== void 0 ? _e : {}).map(([code, name]) => ({
        key: code,
        value: code,
        text: name
    }))) !== null && _f !== void 0 ? _f : [];
    const onSelectSector = (event, data) => {
        if (!preventDefault) {
            if (data.value) {
                let locHash = pathTemplate.replace(`{${fieldName}}`, data.value);
                if (scrollTop === false) {
                    locHash += "?noscroll";
                }
                window.location.hash = locHash;
            }
            if (!stayInFocus || virtkbd()) {
                requestAnimationFrame(() => {
                    document.querySelector('.kb-labfront .kb-sector-selector').focus();
                });
            }
        }
        if (onSelect) {
            onSelect(data.value);
        }
    };
    const clsx = [
        'page-element',
        'kb-selector',
        'kb-sector-selector',
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    return (_jsx("div", { className: clsx, tabIndex: -1, children: _jsx(Dropdown, { placeholder: prompt !== null && prompt !== void 0 ? prompt : "Velg sektor", fluid: true, search: true, selection: true, clearable: clearable, value: currentSelection, options: opts, onChange: onSelectSector, onClick: onClick }) }));
};
